'use strict';

export const getVars = ({style}) => {
    const root = document.querySelector(':root');
    setButtonShape(style.button, root);
    setFont(style.font, root);
    setColors(style.colors, root);
    setLeftNavBarBottomMove(root);
    setAmountOfButtonsOnOptionsCard(root);
};

const setButtonShape = (buttons, root) => {
    root.style.setProperty('--buttonShape', "var(--" + buttons.shape + ")");
};

const setFont = (font, root) => {
    root.style.setProperty('--font', font + ', Open Sans');
};

const setColors = (colors, root) => {
    colors.forEach(color => {
        switch (color.key) {
            case 'brand1':

                let arrBrand1Rgba = (color.value.replace(/ /g, "").split(","));
                let arrHsl = rgbToHsl(arrBrand1Rgba[0], arrBrand1Rgba[1], arrBrand1Rgba[2], arrBrand1Rgba[3]);

                root.style.setProperty('--menuBg', `rgba(${color.value})`);
                root.style.setProperty('--primaryBg', `hsl(${arrHsl[0]}deg,${arrHsl[1]}%,${arrHsl[2] - 4}%,${arrHsl[3]})`);


                let textColor = (arrHsl[2] < 60)?"255,255,255,1":"0,0,0,1";

                root.style.setProperty('--textColor', `rgba(${textColor})`);
                config.style.colors.push({key:'textColor', value:textColor});
                let arrTxtRgba = (textColor.replace(/ /g, "").split(","));
                root.style.setProperty('--borderColor', `rgba(${arrTxtRgba[0]},${arrTxtRgba[1]},${arrTxtRgba[2]},0.2)`);

                break;


            case 'brand2':

                let arrBrand2Rgba = (color.value.replace(/ /g, "").split(","));
                root.style.setProperty('--activeBg', `rgba(${arrBrand2Rgba[0]},${arrBrand2Rgba[1]},${arrBrand2Rgba[2]},0.2)`);

                break;

        }
        root.style.setProperty('--' + color.key, "rgba(" + color.value + ")");
    });
};

const setLeftNavBarBottomMove = (root) => {
    root.style.setProperty('--left-bar-bottom-move', "initial");
};

export const setAmountOfButtonsOnOptionsCard = (root, amount = 0) => {
    root.style.setProperty('--buttonAmount', `${amount}`);
};


function rgbToHsl(r, g, b, a) {
    // Make r, g, and b fractions of 1
    r /= 255;
    g /= 255;
    b /= 255;

    // Find greatest and smallest channel values
    let cmin = Math.min(r, g, b),
        cmax = Math.max(r, g, b),
        delta = cmax - cmin,
        h = 0,
        s = 0,
        l = 0;

    // Calculate hue
    // No difference
    if (delta == 0)
        h = 0;
    // Red is max
    else if (cmax == r)
        h = ((g - b) / delta) % 6;
    // Green is max
    else if (cmax == g)
        h = (b - r) / delta + 2;
    // Blue is max
    else
        h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    // Make negative hues positive behind 360°
    if (h < 0)
        h += 360;

    // Calculate lightness
    l = (cmax + cmin) / 2;

    // Calculate saturation
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

    // Multiply l and s by 100
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    return [h, s, l, a];
}
